import { useCallback, useEffect, useState } from 'react';

export const useDocumentVisibility = () => {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  const callback = useCallback(() => setIsVisible(!document.hidden), []);

  useEffect(() => {
    document.addEventListener('visibilitychange', callback);

    return () => document.removeEventListener('visibilitychange', callback);
  }, [callback]);

  return isVisible;
};
